export default {
  title: 'Liefersoft',
  form: {
    company_id: 'Bedrijfs-id',
    login: 'Login',
    password: 'Wachtwoord',
  },
  buttons: {
    save: 'Opslaan',
    edit: 'Bewerken',
    cancel: 'Annuleren',
  },
  toasts: {
    error: 'Wijzigingen opslaan mislukt',
    success: 'Wijzigingen opgeslagen',
  },
  instructions: {
    title: 'Installatie-instructies:',
    steps: {
      1: 'Ga naar „Instellingen" > „Programma-instellingen" > „API/Interfaces".',
      2: 'Platform toevoegen:\n• Klik op de knop „Platforms".\n• Voer een gebruikersnaam in (bijv. de naam van het platform).\n• Klik op „Opslaan".',
      3: 'API-gegevens kopiëren:\n• Na het opslaan verschijnt een venster met de API-platformcode.\n• Kopieer de weergegeven gegevens.',
    },
  },
  connected: {
    title: 'Liefersoft is verbonden',
    description: 'Deze integratie is ingesteld.',
  },
};
